$(document).ready(function() {
	let setAnimation = function ($item) {
		$item.addClass($item.data('animation'));
	};

	if (typeof IntersectionObserver === 'function') {
		let observer = new IntersectionObserver(function (list) {
			$.each(list, function (index, item) {
				if ((item.isIntersecting === undefined && item.intersectionRatio > 0) || item.isIntersecting) {
					observer.unobserve(item.target);
					let $item = $(item.target);
					setAnimation($item);
				}
				else {
					let $item = $(item.target);
					$item.removeClass($item.data('animation'));
				}
			});
		}, {rootMargin: '100px', threshold: 0});

		$('[data-animation]').each(function () {
			observer.observe(this);
		});
	}
	else {
		$('[data-animation]').each(function () {
			setAnimation($(this));
		});
	}
});
